import { Autocomplete, Box, TextField } from '@mui/material';
import { DISTANCE_UNITS } from '../../../common/distanceFormat';
import { formatNumberValue } from '../../../common/numberFormat';

const DistanceConfiguration = ({ config, onChange }) => {
  const previewConfig = {
    ...config,
    decimal_places:
      config.decimal_places === '' || config.decimal_places === undefined
        ? undefined
        : Number(config.decimal_places)
  };
  return (
    <>
      <Autocomplete
        options={DISTANCE_UNITS}
        groupBy={(unit) => unit.system}
        value={
          DISTANCE_UNITS.find(({ value }) => value === config.distance_unit) ||
          null
        }
        getOptionLabel={({ label, symbol }) => label + ' — ' + symbol}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        onChange={(_, unit) =>
          onChange({
            target: { name: 'distance_unit', value: unit?.value || '' }
          })
        }
        renderInput={(params) => (
          <TextField {...params} margin="dense" label="Distance Unit" />
        )}
      />
      <Box mt={1}>
        Preview: <bdi>{formatNumberValue(1234.56, previewConfig)}</bdi>
      </Box>
      <Box mt={1}>
        Changing the distance unit relabels existing values without converting
        amounts.
      </Box>
    </>
  );
};

export default DistanceConfiguration;
